<template>
  <div
    class="at-eg-task"
    :class="[classFloor, workClass]"
    :title="task.title"
    :style="'width:'+task.duration*100+'%;z-index: 999;'"
  >
    <div class="at-eg-task-inner">{{task.title}}</div>
  </div>
</template>
<style scoped>
/*这里定义的颜色，是甘特图的颜色，对应下方的 classArr 数组*/
.at-eg-index .at-eg-task-inner {
  z-index: 9999;
}

.at-eg-warning .at-eg-task-inner {
  background: #fdedd6 !important;
  color: #f8f8f8;
  border: none;
}

.at-eg-danger .at-eg-task-inner {
  background: #ec808d !important;
  color: #f8f8f8;
  border: none;
  opacity: 0.6;
}
.at-eg-info .at-eg-task-inner {
  background: #bcbcbc !important;
  color: #f8f8f8;
  border: none;
}

.at-eg-working .at-eg-task-inner {
  background: #aaded4 !important;
  color: #f8f8f8;
  border: none;
}
.at-eg-default .at-eg-task-inner {
  background: #02a7f0 !important;
  color: #f8f8f8;
  border: none;
}
.at-eg-primary .at-eg-task-inner {
  background: #1aa689 !important;
  color: #f8f8f8;

  border: none;
}
.at-eg-task-inner {
  text-overflow: unset;
}
</style>
<script>
export default {
  props: {
    task: {
      type: Object,
      required: true
    },
    floorIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      classArr: [
        "info",
        "warning",
        "primary",
        "danger",
        "working",
        "default",
        "primary"
      ]
    };
  },
  computed: {
    classLength() {
      return "at-eg-len-" + this.task.duration;
    },
    // classFloor 控制上下位置
    classFloor() {
      return "at-eg-floor-" + this.floorIndex;
    },
    workClass() {
      // console.log(`this.worktype${this.task.worktype}`, `this.task.title${this.task.title}`)
      let res = `at-eg-${this.classArr[this.task.worktype]}`;
      if (this.task.worktype == 3 && this.task.title === "选中") {
        res = `at-eg-danger at-eg-index`;
      }
      return res;
    }
  },
  mounted() {
    // console.log(this.task)
  }
};
</script>
